import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the search bar to find classrooms by <strong>name</strong> or other criteria. Filter results to narrow your search." id="use_the_search_bar_to_find_classrooms_by.76622f35" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Searching Classrooms" id="searching_classrooms.b9bfca94" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Create Classroom</strong> to set up a new classroom. Provide a name, assign an instructor, and configure classroom settings." id="click_create_classroom_to_set_up_a_new_c.209d5088" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Creating a Classroom" id="creating_a_classroom.e5c3b3e5" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Select a classroom to view its details. Use the <strong>tabs</strong> to manage classroom content, view enrolled students, track activity, and access reports." id="select_a_classroom_to_view_its_details_u.996d66a6" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Classroom Details" id="classroom_details.b3a8f0fd" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Add <strong>courses and resources</strong> to a classroom so enrolled students have access to the assigned materials." id="add_courses_and_resources_to_a_classroom.cde7a176" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Assigning Content" id="assigning_content.52ba01bb" />
        }
    ],
    title: <FormattedMessage defaultMessage="Classrooms" id="classrooms.e66138fb" />
};
